var render = function () {
  var _this = this;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('BOverlay', {
    attrs: {
      "show": _vm.loadingSearch || _vm.loadingCalculatePrice,
      "rounded": "sm",
      "variant": "transparent",
      "spinner-variant": "info",
      "opacity": "0.95",
      "no-fade": ""
    }
  }, [_c('AppCollapse', {
    staticClass: "mb-75",
    attrs: {
      "type": "card"
    }
  }, [_c('AppCollapseItem', {
    attrs: {
      "title": "",
      "isVisible": "",
      "classHeader": "border-bottom",
      "classBody": "p-50"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          class: "text-airline fw-700 ".concat(_vm.isMobileView ? 'font-medium-2' : 'font-medium-3')
        }, [_vm._v(" Chuyến bay đã chọn ")])];
      },
      proxy: true
    }])
  }, [_c('ClassBookingProBookTrip')], 1)], 1), _c('AppCollapse', {
    staticClass: "mb-75",
    attrs: {
      "type": "card"
    }
  }, [_c('AppCollapseItem', {
    attrs: {
      "title": "",
      "isVisible": "",
      "classHeader": "border-bottom",
      "classBody": "p-50"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          class: "text-airline fw-700 ".concat(_vm.isMobileView ? 'font-medium-2' : 'font-medium-3')
        }, [_vm._v(" Tính giá ")])];
      },
      proxy: true
    }])
  }, [_c('ClassBookingProBookCalculateOption')], 1)], 1), _c('AppCollapse', {
    staticClass: "mb-75",
    attrs: {
      "type": "card"
    }
  }, [_c('AppCollapseItem', {
    attrs: {
      "title": "",
      "isVisible": "",
      "classHeader": "border-bottom",
      "classBody": "p-50"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          class: "text-airline fw-700 ".concat(_vm.isMobileView ? 'font-medium-2' : 'font-medium-3')
        }, [_vm._v(" Giá vé "), _vm.resultCalculatePrice ? [_vm._v(" ( "), _c('span', {
          staticClass: "text-airline"
        }, [_vm._v(_vm._s(_vm.resultCalculatePrice[0].currency))]), _vm._v(" ) ")] : _vm._e()], 2)];
      },
      proxy: true
    }])
  }, [_c('ClassBookingProBookPrice')], 1)], 1), _c('ValidationObserver', {
    ref: "refPaxAndCustomerInfo"
  }, [_c('AppCollapse', {
    staticClass: "mb-75",
    attrs: {
      "type": "card"
    }
  }, [_c('AppCollapseItem', {
    ref: "refPaxCollapseItem",
    attrs: {
      "title": "",
      "isVisible": "",
      "classHeader": "border-bottom",
      "classBody": "p-50"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          class: "text-airline fw-700 ".concat(_vm.isMobileView ? 'font-medium-2' : 'font-medium-3')
        }, [_vm._v(" Thông tin hành khách ")])];
      },
      proxy: true
    }])
  }, [_c('ClassBookingProBookPassenger', {
    attrs: {
      "customerId": _vm.customerId,
      "passengerDataToAdd": _vm.passengerLists
    }
  })], 1)], 1), _c('b-card', {
    staticClass: "shadow",
    attrs: {
      "no-body": ""
    }
  }, [_c('BookingAgencyDetail', {
    attrs: {
      "agency-data": _vm.agencyData,
      "checkboxCustomerDataReplacePhoneAgencyData": _vm.checkboxCustomerDataReplacePhoneAgencyData,
      "checkboxCustomerDataReplaceEmailAgencyData": _vm.checkboxCustomerDataReplaceEmailAgencyData,
      "is-role-f1": _vm.isRoleF1,
      "enable-send-employee-mail-airline": _vm.enableSendEmployeeMailAirline,
      "is-collapsed": _vm.isCollapsedAgencyAndContactDetail
    },
    on: {
      "update:agencyData": function updateAgencyData($event) {
        _vm.agencyData = $event;
      },
      "update:agency-data": function updateAgencyData($event) {
        _vm.agencyData = $event;
      },
      "update:checkboxCustomerDataReplacePhoneAgencyData": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-phone-agency-data": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkboxCustomerDataReplaceEmailAgencyData": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-email-agency-data": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "toggleCollapse": _vm.toggleIsCollapsedAgencyAndContactDetail
    }
  }), _c('BookingContactDetail', {
    attrs: {
      "customer-data": _vm.customerData,
      "checkboxCustomerDataReplacePhoneAgencyData": _vm.checkboxCustomerDataReplacePhoneAgencyData,
      "checkboxCustomerDataReplaceEmailAgencyData": _vm.checkboxCustomerDataReplaceEmailAgencyData,
      "is-role-f3": _vm.isRoleF3,
      "is-collapsed": _vm.isCollapsedAgencyAndContactDetail
    },
    on: {
      "update:customerData": function updateCustomerData($event) {
        _vm.customerData = $event;
      },
      "update:customer-data": function updateCustomerData($event) {
        _vm.customerData = $event;
      },
      "update:checkboxCustomerDataReplacePhoneAgencyData": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-phone-agency-data": function updateCheckboxCustomerDataReplacePhoneAgencyData($event) {
        _vm.checkboxCustomerDataReplacePhoneAgencyData = $event;
      },
      "update:checkboxCustomerDataReplaceEmailAgencyData": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "update:checkbox-customer-data-replace-email-agency-data": function updateCheckboxCustomerDataReplaceEmailAgencyData($event) {
        _vm.checkboxCustomerDataReplaceEmailAgencyData = $event;
      },
      "toggleCollapse": _vm.toggleIsCollapsedAgencyAndContactDetail,
      "resetAgencyData": _vm.resetAgencyData
    }
  })], 1)], 1), _c('div', {
    staticClass: "m-75"
  }, [_c('BFormCheckbox', {
    staticClass: "custom-control-warning",
    attrs: {
      "name": "savePriceToBooking"
    },
    model: {
      value: _vm.retain,
      callback: function callback($$v) {
        _vm.retain = $$v;
      },
      expression: "retain"
    }
  }, [_c('span', {
    staticClass: "font-weight-bold text-body"
  }, [_vm._v(" Lưu giá vé ")])]), _c('p', {
    staticClass: "text-danger font-small-4 font-weight-bolder"
  }, [_vm._v(" Lưu ý: Trong trường hợp đặt sổ chờ (HL), đặt DS hoặc đặt nhiều hạng trên 1 chuyến bay bạn nên tắt chức năng lưu giá vé tránh bị lỗi! ")])], 1), _c('div', {
    staticClass: "d-flex-center mb-1 gap-3"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary",
      "pill": ""
    },
    on: {
      "click": function click() {
        return _this.$router.go(-1);
      }
    }
  }, [_vm._v(" Quay lại ")]), _c('b-button', {
    attrs: {
      "variant": "warning",
      "pill": ""
    },
    on: {
      "click": _vm.createBookingHandle
    }
  }, [_vm._v(" Đặt vé ")])], 1), _vm.resultCreatedBooking ? _c('AppCollapse', {
    staticClass: "mb-75",
    attrs: {
      "type": "card"
    }
  }, [_c('AppCollapseItem', {
    attrs: {
      "title": "",
      "isVisible": "",
      "classHeader": "border-bottom",
      "classBody": "p-50"
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_c('div', {
          class: "text-airline fw-700 ".concat(_vm.isMobileView ? 'font-medium-2' : 'font-medium-3')
        }, [_vm._v(" Booking ")])];
      },
      proxy: true
    }], null, false, 717323143)
  }, [_c('ClassBookingProBookInfoBooking')], 1)], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }